import { getIrrigationActivityScope } from 'App/Map/PanelDetails/StackemCharts/_utils/by-domain/soil/_utils/getIrrigationActivityScope'
import { SectionTitleBarSwitch } from 'components/SectionTitleBarComponents/SectionTitleBarSwitch'
import { translate } from 'i18n/i18n'
import { detailsPanelStore } from 'stores/detailsPanelStore/detailsPanelStore'
import { fieldAssetStore } from 'stores/fieldAssetStore/fieldAssetStore'
import { selectedFieldAssetsStore } from 'stores/selectedFieldAssetsStore/selectedFieldAssetsStore'

export const SoilZoneDevicesToggle = () => {
  const chosenScope = detailsPanelStore.useSelector((s) => s.soilIrrigationActivityScope)

  const { property, soilPoint } = selectedFieldAssetsStore.useSelector((s) => ({
    property: s.property,
    soilPoint: s.soilPoint,
  }))

  const point = fieldAssetStore.useSelector((s) =>
    property && soilPoint ? s.properties?.[property]?.points?.[soilPoint] : null,
  )

  if (!point?.configuration.soilProbeIntersectingZoneIdsWithEmitters?.length) return null

  return (
    <SectionTitleBarSwitch
      checked={getIrrigationActivityScope({ chosenScope, soilPoint: point }) === 'ZONE'}
      onChange={(event) => {
        detailsPanelStore.setState((s) => ({
          ...s,
          soilIrrigationActivityScope: event.target.checked ? 'ZONE' : 'PROBE',
        }))
      }}
      label={<span css={{ fontWeight: 'normal' }}>{translate.phrases.banyanApp('Zone Devices')}</span>}
    ></SectionTitleBarSwitch>
  )
}
